import {type QepComponent} from '@qep/preloads/src/preloads/QEP/containers/Browser/communication/types';
import {getQepSystem} from '@qep/shared/src';
import {type ContainerType} from '@qep/types/src';
import {type IJsonTabNode} from 'flexlayout-react';

export type BrowserContainerType = ContainerType & {
  applicationClient: ContainerType['applicationClient'] & {
    browserContextId?: string;
  };
};

export const getContainer = (): BrowserContainerType => getQepSystem().container as BrowserContainerType;

export function toTabNode(component: QepComponent): IJsonTabNode {
  return {
    type: 'tab',
    // id: component.windowId,
    name: component.name,
    component: 'multitype',
    config: {
      spawnDataId: component?.configs?.spawnDataId,
      componentId: component?.configs?.componentId,
      type: 'url',
      data: component.url,
      linkerGroups: component?.configs?.linkerGroups || [],
    },
  };
}
